import OtpPage from "./OtpPage";
import { useAuth } from "./AuthContext";

const LoginVerifyPage = () => {
  const { verifyLogin } = useAuth();
  return <OtpPage title="ورود" verify={verifyLogin} />;
};

export default LoginVerifyPage;
